import React, { useEffect, useRef } from 'react';
import './FullScreenOverlay.css';

const FullScreenOverlay = ({ children, modalOpen, setModalOpen }) => {
    const overlayRef = useRef(null); // Reference to the overlay div

    useEffect(() => {
        if (modalOpen) {
            document.body.style.overflow = 'hidden';  // Disable scrolling

        } else {
            document.body.style.overflow = 'unset';  // Enable scrolling

        }

        // Return a cleanup function that will be called on unmount
        return () => {
            document.body.style.overflow = 'unset';  // Enable scrolling
        };
    }, [modalOpen]);

    useEffect(() => {
        if (setModalOpen) {
            const handleClickOutside = (event) => {
                // Check if the click was outside the overlay content
                if (overlayRef.current && !overlayRef.current.contains(event.target)) {
                    setModalOpen(false); // Set close to true if click is outside
                }
            };

            // Add event listener when the component is mounted
            document.addEventListener('mousedown', handleClickOutside);

            // Cleanup the event listener when the component is unmounted
            return () => {

                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [setModalOpen]);

    return (
        // white_gradient
        <div className="fullscreen-overlay white_gradient">
            <div className="overlay-content">
                <div className='flex justify_center align_center' ref={overlayRef}>
                    {children} {/* This will display the passed content */}
                </div>
            </div>
        </div>
    );
};

export default FullScreenOverlay;